import { type Environment } from '@openeducation/oe-it-services';

import MessageDao from './dao/message.dao';
import type {
  MessageItem,
  MessageNotification,
} from '../interfaces/message-notification';

export abstract class MessageService {
  static async remove(
    env: Environment,
    notificationId: string,
    teacherId?: number
  ) {
    if (!teacherId) {
      throw new Error('Missing teacherId');
    }

    return MessageDao.remove(env, notificationId, teacherId);
  }
  static async getMessages(
    env: Environment,
    teacherId?: number,
    page: number = 1,
    itensPerPage: number = 5,
    sortParm: string = 'CREATEDDATE'
  ): Promise<MessageItem[]> {
    if (!teacherId) {
      throw new Error('Missing teacherId');
    }

    const { notifications } = await MessageDao.getMessage(
      env,
      teacherId,
      page,
      itensPerPage,
      sortParm
    );

    return notifications[1];
  }
  static async create(env: Environment, message: MessageNotification) {
    if (!message.sentByPersonId) {
      throw new Error('Missing sentByPersonId');
    }
    try {
      await MessageDao.create(env, message);
      return true;
    } catch (_e) {
      return false;
    }
  }
}
